import {
  createCarHouseSubscription,
  getCarHouseSubscriptions,
  updateCarHouseSubscription,
  createUserSubscription,
  getUserSubscriptions,
  updateUserSubscription,
  cancelSubscription,
  addCarHouseCredits,
  addUserCredits,
  purchaseVehicle,
  updateSubscription
} from '../../lib/subscriptionsAndCredits';
import { createAsyncThunk } from '@reduxjs/toolkit';

// ** CarHouse Subscriptions **

export const addCarHouseSubscription = createAsyncThunk(
  'subscriptions/createCarHouseSubscription',
  async ({ carHouseId, body }, { rejectWithValue }) => {
    try {
      const data = await createCarHouseSubscription(carHouseId, body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchCarHouseSubscriptions = createAsyncThunk(
  'subscriptions/getCarHouseSubscriptions',
  async ({ carHouseId, pagination, options = {} }) => {
    const data = await getCarHouseSubscriptions(carHouseId, pagination, options);
    return data;
  }
);

export const editCarHouseSubscription = createAsyncThunk(
  'subscriptions/updateCarHouseSubscription',
  async ({ carHouseId, subscriptionId, body }, { rejectWithValue }) => {
    try {
      const data = await updateCarHouseSubscription(carHouseId, subscriptionId, body);
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || 'Unexpected error');
    }
  }
);

export const editSubscription = createAsyncThunk(
  'subscriptions/updateSubscription',
  async ({ subscriptionId, body }, { rejectWithValue }) => {
    try {
      const data = await updateSubscription(subscriptionId, body);
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || 'Unexpected error');
    }
  }
);

// ** User Subscriptions **

export const createUserSubscriptionAction = createAsyncThunk(
  'subscriptions/createUserSubscription',
  async ({ userId, body }, { rejectWithValue }) => {
    try {
      const data = await createUserSubscription(userId, body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getUserSubscriptionsAction = createAsyncThunk(
  'subscriptions/getUserSubscriptions',
  async ({ userId, query }) => {
    const data = await getUserSubscriptions(userId, query);
    return data;
  }
);

export const updateUserSubscriptionAction = createAsyncThunk(
  'subscriptions/updateUserSubscription',
  async ({ userId, subscriptionId, body }) => {
    const data = await updateUserSubscription(userId, subscriptionId, body);
    return data;
  }
);

export const cancelSubscriptionAction = createAsyncThunk(
  'subscriptions/cancelSubscription',
  async (subscriptionId) => {
    const data = await cancelSubscription(subscriptionId);
    return data;
  }
);

// ** Credits **

export const addCarHouseCreditsAction = createAsyncThunk(
  'subscriptions/addCarHouseCredits',
  async ({ carHouseId, body }) => {
    const data = await addCarHouseCredits(carHouseId, body);
    return data;
  }
);

export const addUserCreditsAction = createAsyncThunk(
  'subscriptions/addUserCredits',
  async ({ userId, body }) => {
    const data = await addUserCredits(userId, body);
    return data;
  }
);

// ** Vehicle Purchase **

export const purchaseVehicleAction = createAsyncThunk(
  'subscriptions/purchaseVehicle',
  async ({ userId, vehicleId }) => {
    const data = await purchaseVehicle(userId, vehicleId);
    return data;
  }
);
